import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {Table} from '../../../components/table/table.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';

interface OwnProps {
    occasion: OccasionType;
}
export function Technical({occasion}: OwnProps) {
    return (
        <div className={styles.tabs_grid}>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell name={__('occasions.details.general_fields.build_year')} value={occasion.build_year} />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell name={__('occasions.details.general_fields.build_month')} value={occasion.build_month} />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.cylinder_capacity')}
                        value={`${occasion.cylinder_capacity !== '' ? occasion.cylinder_capacity : '-'} ${occasion.cylinder_capacity_type}`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.number_of_cylinders')}
                        value={occasion.cylinders}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.power')}
                        value={`${occasion.power} ${occasion.power_type}`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell name={__('occasions.details.general_fields.torque')} value={`${occasion.torque} Nm`} />
                </TableRow>
            </Table>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.model_range')}
                        value={`${occasion.model_range_from} ${__('general.from_till')} ${occasion.model_range_till}`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.top_speed')}
                        value={`${occasion.top_speed} km/h`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.acceleration')}
                        value={`${occasion.acceleration} sec`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.number_of_gears')}
                        value={occasion.number_of_gears}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.weight')}
                        value={`${occasion.weight} ${occasion.weight_type}`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.max_towing_weight')}
                        value={occasion.max_towing_weight}
                    />
                </TableRow>
            </Table>
        </div>
    );
}
